function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ""
}

function decodeBase64url(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4)
  const binary = atob(value.replace(/-/g, "+").replace(/_/g, "/") + padding)
  return Uint8Array.from(binary, (character) => character.charCodeAt(0))
}

function encodeBase64url(value) {
  const bytes = new Uint8Array(value)
  let binary = ""
  bytes.forEach((byte) => { binary += String.fromCharCode(byte) })
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

function prepareCreationOptions(options) {
  options.challenge = decodeBase64url(options.challenge)
  options.user.id = decodeBase64url(options.user.id)
  options.excludeCredentials = (options.excludeCredentials || []).map((credential) => ({
    ...credential,
    id: decodeBase64url(credential.id),
  }))
  return options
}

function prepareRequestOptions(options) {
  options.challenge = decodeBase64url(options.challenge)
  options.allowCredentials = (options.allowCredentials || []).map((credential) => ({
    ...credential,
    id: decodeBase64url(credential.id),
  }))
  return options
}

function serializeCredential(credential) {
  const response = {
    clientDataJSON: encodeBase64url(credential.response.clientDataJSON),
  }

  if (credential.response.attestationObject) {
    response.attestationObject = encodeBase64url(credential.response.attestationObject)
    response.transports = credential.response.getTransports?.() || []
  } else {
    response.authenticatorData = encodeBase64url(credential.response.authenticatorData)
    response.signature = encodeBase64url(credential.response.signature)
    response.userHandle = credential.response.userHandle ? encodeBase64url(credential.response.userHandle) : null
  }

  return {
    id: credential.id,
    rawId: encodeBase64url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    clientExtensionResults: credential.getClientExtensionResults(),
    response,
  }
}

async function postJson(url, body = {}) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify(body),
  })
  const json = await response.json()
  if (!response.ok) throw new Error(json.error || "操作失敗，請稍後再試。")
  return json
}

function statusFor(button) {
  return button.closest(".auth-card, .passkey-enroll")?.querySelector("[data-passkey-status]")
}

function presentError(error) {
  if (error.name === "NotAllowedError") return "操作已取消，或裝置沒有可用的登入憑證。"
  return error.message || "無法完成操作，請稍後再試。"
}

function initializePasskeys() {
  document.querySelectorAll("[data-passkey-login], [data-passkey-register]").forEach((button) => {
    if (button.dataset.passkeyInitialized === "true") return
    button.dataset.passkeyInitialized = "true"
    const status = statusFor(button)

    if (!window.PublicKeyCredential || !navigator.credentials) {
      button.disabled = true
      if (status) status.textContent = "此瀏覽器不支援指紋或人臉辨識，請使用 Email 驗證碼或 Google。"
      return
    }

    button.addEventListener("click", async () => {
      button.disabled = true
      if (status) status.textContent = "正在等待裝置確認…"

      try {
        const options = await postJson(button.dataset.optionsUrl)
        const registering = button.hasAttribute("data-passkey-register")
        const credential = registering
          ? await navigator.credentials.create({ publicKey: prepareCreationOptions(options) })
          : await navigator.credentials.get({ publicKey: prepareRequestOptions(options) })
        const body = { credential: serializeCredential(credential) }
        if (registering) body.nickname = document.querySelector("#passkey-nickname")?.value || ""
        const result = await postJson(button.dataset.createUrl, body)
        window.location.assign(result.redirect_url)
      } catch (error) {
        if (status) status.textContent = presentError(error)
        button.disabled = false
      }
    })
  })
}

document.addEventListener("DOMContentLoaded", initializePasskeys)
document.addEventListener("turbo:load", initializePasskeys)
